module.exports = __webpack_public_path__ + "static/media/c1-class@2x.787929c9.png";